// import { proxy, wrap } from 'comlink';
import { useEffect } from 'react';

import { renderPDF } from '../components/partials/form-preview/e-sign/pdf-renderer.js';
import useAsync from './async.js';

// const pdfWorker = wrap(new Worker('../../components/form/sw', { type: 'module' }));

// pdfWorker.onProgress(proxy((info) => console.log('Worker PDF progress: ', info)));

const pdfRenderer = async ({ templateProps }) => {
  try {
    const { totalPages, blob } = await renderPDF(templateProps);
    return {
      url: URL.createObjectURL(blob),
      totalPages,
      blob
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const useRenderPDF = ({ templateProps }) => {
  const { value, loading, error } = useAsync(
    // async () => pdfWorker.renderPDFInWorker({
    async () => pdfRenderer({ templateProps }),
    [templateProps]
  );

  const totalPages = value?.totalPages;
  const document = value?.blob;
  const url = value?.url;

  useEffect(() => {
    url ? () => URL.revokeObjectURL(url) : undefined;
  }, [url]);

  return {
    totalPages,
    document,
    loading,
    error,
    url
  };
};